export function showAuth() {
    const $link = $('.js-link-auth-forms');

    if ($link.length) {
        $link.first().click();
    }
}